import { CUTOFF_LUNCH_MENU_LIST, CUTOFF_SCHEDULE_LIST } from "../../actionTypes/admin";

const intialState = {
  cutoffLunchMenuList: [],
  cutoffScheduleList: [],
};

export default function CutoffLunchMenuReducers(state = intialState, action) {
  switch (action.type) {

    case CUTOFF_LUNCH_MENU_LIST:
      return { ...state, cutoffLunchMenuList: action.payload };

    case CUTOFF_SCHEDULE_LIST:
      return { ...state, cutoffScheduleList: action.payload };

    default:
      return state;
  }
}
